/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './popup.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '../../booking-management/cancel-reason-popup/cancel-reason-popup.component.ngfactory';
import * as import3 from '../../../../app/booking-management/cancel-reason-popup/cancel-reason-popup.component';
import * as import4 from '@angular/material';
import * as import5 from 'md2/core/compatibility/compatibility';
import * as import6 from '../../../../app/shared/popup/popup.component';
import * as import7 from '@angular/common';
import * as import8 from '../../../../app/notification/notification.service';
const styles_PopupComponent:any[] = [import0.styles];
export const RenderType_PopupComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_PopupComponent,
  data: {}
}
);
function View_PopupComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-cancel-reason-popup',([] as any[]),(null as any),[[
        (null as any),
        'cancellationReason'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('cancellationReason' === en)) {
        const pd_0:any = ((<any>co.cancellationReasonHandler($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import2.View_CancelReasonPopupComponent_0,import2.RenderType_CancelReasonPopupComponent)),
    import1.ɵdid(49152,(null as any),0,import3.CancelReasonPopupComponent,([] as any[]),(null as any),{cancellationReason: 'cancellationReason'})
  ]
  ,(null as any),(null as any));
}
function View_PopupComponent_2(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[
      [
        'class',
        'button red'
      ]
      ,
      [
        'name',
        'noBtn'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.closeDialog(false,false)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      ' ',
      ' '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.cancelTitle;
    ck(v,1,0,currVal_0);
  });
}
export function View_PopupComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),43,'div',[[
        'class',
        'md-dialog'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n	'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),25,'md-dialog-content',([] as any[]),[[
        2,
        'mat-dialog-content',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import4.MdPrefixRejector,[
      [
        2,
        import4.MATERIAL_COMPATIBILITY_MODE
      ]
      ,
      import1.ElementRef
    ]
    ,(null as any),(null as any)),
      import1.ɵdid(16384,(null as any),0,import5.MdPrefixRejector,[[
        2,
        import5.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    import1.ɵdid(16384,(null as any),0,import4.MdDialogContent,([] as any[]),(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n		'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'header',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n			'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'h1',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n			'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[[
        'name',
        'cancel-popup'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import6.PopupComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.closeDialog(co.closeVal,true)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'icon-close'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n		'])),
    (l()(),import1.ɵted((null as any),['\n		'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),10,'main',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n			'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n				'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n			'])),
    (l()(),import1.ɵted((null as any),['\n			'])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PopupComponent_1)),
    import1.ɵdid(16384,(null as any),0,import7.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n		'])),
    (l()(),import1.ɵted((null as any),['\n	'])),
    (l()(),import1.ɵted((null as any),['\n\n	'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),13,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n		'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),10,'md-dialog-actions',([] as any[]),[[
        2,
        'mat-dialog-actions',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import4.MdPrefixRejector,[
      [
        2,
        import4.MATERIAL_COMPATIBILITY_MODE
      ]
      ,
      import1.ElementRef
    ]
    ,(null as any),(null as any)),
      import1.ɵdid(16384,(null as any),0,import5.MdPrefixRejector,[[
        2,
        import5.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    import1.ɵdid(16384,(null as any),0,import4.MdDialogActions,([] as any[]),(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n			'])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PopupComponent_2)),
    import1.ɵdid(16384,(null as any),0,import7.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n			'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[
      [
        'class',
        'button'
      ]
      ,
      [
        'name',
        'yesBtn'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import6.PopupComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.closeDialog(true,false)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      ' ',
      ' '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n		'])),
    (l()(),import1.ɵted((null as any),['\n	'])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import6.PopupComponent = v.component;
    const currVal_3:any = co.needReasonComponent;
    ck(v,25,0,currVal_3);
    const currVal_5:any = (co.cancelTitle.length > 0);
    ck(v,37,0,currVal_5);
  },(ck,v) => {
    var co:import6.PopupComponent = v.component;
    const currVal_0:any = true;
    ck(v,2,0,currVal_0);
    const currVal_1:any = co.title;
    ck(v,10,0,currVal_1);
    const currVal_2:any = co.popupMessage;
    ck(v,21,0,currVal_2);
    const currVal_4:any = true;
    ck(v,31,0,currVal_4);
    const currVal_6:any = co.okTitle;
    ck(v,40,0,currVal_6);
  });
}
function View_PopupComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-popup',([] as any[]),(null as any),(null as any),(null as any),View_PopupComponent_0,RenderType_PopupComponent)),
    import1.ɵdid(49152,(null as any),0,import6.PopupComponent,[
      import4.MdDialogRef,
      import8.NotificationServiceBus,
      import4.MD_DIALOG_DATA
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const PopupComponentNgFactory:import1.ComponentFactory<import6.PopupComponent> = import1.ɵccf('app-popup',import6.PopupComponent,View_PopupComponent_Host_0,{
  title: 'title',
  popupMessage: 'popupMessage',
  okTitle: 'okTitle',
  cancelTitle: 'cancelTitle',
  closeVal: 'closeVal',
  needReasonComponent: 'needReasonComponent'
}
,{cancelReason: 'cancelReason'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/shared/popup/popup.component.ngfactory.ts